import React, { useState } from 'react';
import './PlasticBuckets.css';
import Plastbuckets1 from '../../../imgs/Plastbuckets1.webp';
import Plastbuckets2 from '../../../imgs/Plastbuckets2.webp';
import Plastbuckets3 from '../../../imgs/Plastbuckets3.webp';
import Plastbuckets4 from '../../../imgs/Plastbuckets4.webp';
import Reqprodcte from "../../../components/Reqprodcte";

const images = [
    { src: Plastbuckets1 },
    { src: Plastbuckets2 },
    { src: Plastbuckets3 },
    { src: Plastbuckets4 },
];

const PlasticBuckets = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="Plastbucket-main-container">

            <div className="Plastbucket-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"}  key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" data-aos="fade-down" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="Plastbucket-text">
                <h2>Plastic Buckets Injection Molding Machine</h2>
                <h3>PB SERIES</h3>
                <p>
                    PB Series plastic bucket injection molding machine are specialized for PP plastic bucket. Higher productivity and more stable production with improved machine which specialized for making bucket.                </p>
                <ul>
                    <li><strong>Clamping Force:</strong> –  500/680(Ton)</li>
                                        <li><strong>Shot Weight(PS):</strong> –  2847(g)</li>

                    <li><strong>Injection Speed :</strong> -  725/848(g/s)</li>
                </ul>
 <div className='stnd'>
                    <Reqprodcte />
                </div>                </div>
        </div>
    );
};
export default PlasticBuckets;
